"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 35.113 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M32.365 16.38a7.885 7.885 0 00-.857-.055c-.33-.004-1.063-.026-2.016-.061l.005-.019a.22.22 0 00-.213-.223l-.656-.019a.217.217 0 00-.224.21l.002.009c-2.426-.099-5.632-.258-7.61-.433a.204.204 0 00.032-.1.22.22 0 00-.213-.223l-.655-.019a.218.218 0 00-.224.21c0 .006.002.011.003.016-.308-.061-.55-.219-.766-.44l.367-.283a.868.868 0 00.347-.551c.054-.305-.05-.627-.309-.955l-.758-.959c-.26-.328-.55-.506-.863-.528a.879.879 0 00-.625.2l-.506.391.036.046c-.564-.362-1.297-.647-2.296-.77-1.809-.222-1.717.225-2.802.092-.893-.11-1.492-.769-2.278-1.401a.205.205 0 00.057-.06.217.217 0 00-.071-.298l-.559-.343a.22.22 0 00-.301.07c-.005.007-.006.016-.009.024a4.709 4.709 0 00-1.775-.581 6.56 6.56 0 00-1.429-.009C.519 9.76.112 15.12.089 15.304c-.022.183-.923 5.475 3.511 7.036.507.178.967.285 1.388.337 2.65.325 3.772-1.519 5.414-1.317 1.085.133.888.545 2.696.767 4.051.497 4.365-2.659 6.246-2.429 2.608.32 10.193 1.905 11.478 2.208.303.072.584.122.845.154 2.975.365 3.307-1.675 3.404-2.465.098-.789.269-2.849-2.706-3.215zm-14.669-3.56c.015-.003.104.032.234.197l.758.959c.128.162.14.254.135.274l-.384.297c-.304-.45-.633-.967-1.121-1.434l.378-.293z", fillRule: "evenodd", clipRule: "evenodd" })));
};
var SvgGuitarCase = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgGuitarCase;
var templateObject_1;
